import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import ToolView from 'views/toolbar'; // Importing the toolbar view
import MenuView from 'views/menu'; // Importing the menu view
import { getLangsList } from 'models/langslist'; // Importing function to get languages list
import { devConfig, version } from '../config/config'; // Importing development configuration and version

/**
 * TopView class extending JetView to create the main application view.
 */
export default class TopView extends JetView {
    /**
     * Configures the layout of the TopView.
     * @returns {Object} Layout configuration object.
     */
    config() {
        return {
            id: 'preload-container', // Unique identifier for the container
            rows: [
                ToolView, // Adding the toolbar view to the layout
                {
                    css: 'body-container', // CSS class for styling
                    cols: [
                        MenuView, // Adding the menu view to the layout
                        {
                            type: 'space', // Defining a space type column
                            id: 'right-container', // Unique identifier for the right container
                            minWidth: screen.width < 500 ? 0 : 650, // Minimum width based on screen size
                            css: 'right-container', // CSS class for styling
                            rows: [
                                { $subview: true }, // Placeholder for subviews
                                {
                                    hidden: version === '', // Hides the toolbar if version is empty
                                    view: 'toolbar', // Adding a toolbar view
                                    css: 'toolbar-footer', // CSS class for footer toolbar
                                    height: 30, // Height of the toolbar
                                    elements: [
                                        {
                                            view: 'label', // Adding a label to display the version
                                            label: version, // Setting the label text to the version
                                            align: 'center', // Center alignment for the label
                                            css: 'label-footer', // CSS class for label styling
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the TopView and sets up event listeners.
     */
    init() {
        const lang = this.app.getService('locale').getLang(); // Getting the current language
        if (lang !== 'en') {
            // Checking if the language is not English
            const langs = getLangsList(); // Retrieving the list of languages
            const country = langs.find((l) => l.id === lang).code; // Finding the country code for the language
            webix.i18n.setLocale(lang + '-' + country); // Setting the locale for Webix
        }
        this.on(this.app, 'export:data', (nameReport) => {
            // Listening for export data event
            nameReport.NameReport =
                'Virtualsoft - ' + // Prefix for the report name
                new Date()
                    .toLocaleString('en-GB', { hour12: true }) // Formatting the date
                    .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Replacing date format
                    .replace(/[\/:]/g, '_') // Replacing slashes and colons with underscores
                    .toUpperCase() + // Converting to uppercase
                ' - ' +
                nameReport.NameReport; // Appending the original report name
            webix
                .ajax() // Making an AJAX request
                .headers({
                    'Content-type': 'application/json', // Setting content type for the request
                })
                .post(
                    devConfig.geturlApi() + // API URL for the request
                        'Report/informationDownloadedByUser',
                    {
                        NameReport: nameReport.NameReport, // Sending the report name
                        TypeReport: nameReport.TypeReport, // Sending the report type
                        Filters: webix.storage.local.get('urlAjaxGlobal'), // Sending filters from local storage
                    },
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error callback
                            webix.message('Error! '); // Displaying error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success callback
                            let data2 = JSON.parse(text); // Parsing the response text
                            if (!data2.HasError) {
                                // Checking for errors in the response
                                webix.message({
                                    text: 'Registro guardado con éxito', // Success message
                                    title: _('¡Exito!'), // Title for the success message
                                    type: 'alert-warning', // Type of message
                                });
                            } else {
                                webix.message({
                                    text: 'Error al guardar el registro', // Error message
                                    title: _('¡Error!'), // Title for the error message
                                    type: 'alert-error', // Type of message
                                });
                            }
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
